"use strict";
var DESCRIPTORS = require("../internals/descriptors");
var uncurryThis = require("../internals/function-uncurry-this");
var call = require("../internals/function-call");
var fails = require("../internals/fails");
var objectKeys = require("../internals/object-keys");
var getOwnPropertySymbolsModule = require("../internals/object-get-own-property-symbols");
var propertyIsEnumerableModule = require("../internals/object-property-is-enumerable");
var toObject = require("../internals/to-object");
var IndexedObject = require("../internals/indexed-object");
var $assign = Object.assign;
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);
module.exports = !$assign || fails(function() {
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, "a", {
    enumerable: true,
    get: function() {
      defineProperty(this, "b", {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  var A = {};
  var B = {};
  var symbol = Symbol("assign detection");
  var alphabet = "abcdefghijklmnopqrst";
  A[symbol] = 7;
  alphabet.split("").forEach(function(chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }
  return T;
} : $assign;
